/*
 * Wraps the literal "®" character in visible text nodes with <sup> so it
 * renders as superscript everywhere it appears (product/variant/collection
 * titles, section headings, etc.) without touching JSON-LD, data- and
 * aria- attributes, or script/style content -- those are never text nodes
 * a DOM TreeWalker sees, so they're safe by construction.
 *
 * Runs once synchronously on load (script tag is placed at the end of
 * <body>, un-deferred, so the DOM is already parsed and this completes
 * before first paint -- no flicker), then a MutationObserver reprocesses
 * only newly-added subtrees (cart drawer, predictive search, Zakeke's own
 * body-level observer in theme.liquid) so later content gets wrapped too.
 * Already-wrapped "®" is skipped by ancestor check, so re-running this on
 * the same content (including the mutations this script itself causes)
 * never double-wraps.
 */
(function () {
  'use strict';

  var REG_SYMBOL = '®';
  var SUP_CLASS = 'xp-tm-sup';
  var WRAP_CLASS = 'xp-tm-sup-wrap';
  var SKIP_TAGS = { SCRIPT: true, STYLE: true, NOSCRIPT: true, TEXTAREA: true, IFRAME: true };

  function shouldSkip(node) {
    while (node) {
      if (node.nodeType === 1) {
        if (SKIP_TAGS[node.tagName]) return true;
        if (node.classList && (node.classList.contains(SUP_CLASS) || node.classList.contains(WRAP_CLASS))) return true;
        if (node.isContentEditable) return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  function wrapTextNode(textNode) {
    var text = textNode.nodeValue;
    if (text.indexOf(REG_SYMBOL) === -1) return;

    // Split into a single inline <span> wrapper, not a bare DocumentFragment,
    // so this always replaces the original text node with exactly one new
    // node. A fragment would insert "Tyvek" and <sup> as separate siblings
    // directly in the parent -- harmless in a normal block/inline parent,
    // but if that parent is a flex container (e.g. a nav row with
    // justify-content: space-between), each of those siblings becomes its
    // own flex item, so the layout gets an extra item and the ® drifts away
    // from its word instead of sitting right after it. Wrapping keeps
    // "Tyvek" + <sup>®</sup> as one visual/layout unit no matter what kind
    // of parent it lands in.
    var parts = text.split(REG_SYMBOL);
    var wrapper = document.createElement('span');
    wrapper.className = WRAP_CLASS;

    for (var i = 0; i < parts.length; i++) {
      if (parts[i]) {
        wrapper.appendChild(document.createTextNode(parts[i]));
      }
      if (i < parts.length - 1) {
        var sup = document.createElement('sup');
        sup.className = SUP_CLASS;
        sup.textContent = REG_SYMBOL;
        wrapper.appendChild(sup);
      }
    }

    textNode.parentNode.replaceChild(wrapper, textNode);
  }

  function collectTextNodes(root) {
    var nodes = [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.nodeValue.indexOf(REG_SYMBOL) === -1) return NodeFilter.FILTER_REJECT;
        if (shouldSkip(node.parentNode)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var current;
    while ((current = walker.nextNode())) {
      nodes.push(current);
    }
    return nodes;
  }

  function processSubtree(root) {
    if (!root) return;

    if (root.nodeType === 3) {
      if (root.nodeValue.indexOf(REG_SYMBOL) !== -1 && !shouldSkip(root.parentNode)) {
        wrapTextNode(root);
      }
      return;
    }

    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    if (root.nodeType === 1 && shouldSkip(root)) return;

    var nodes = collectTextNodes(root);
    for (var i = 0; i < nodes.length; i++) {
      wrapTextNode(nodes[i]);
    }
  }

  processSubtree(document.body);

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        processSubtree(added[j]);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
